export enum COST_CALCULATION_TYPE {
  COST_PLUS = "CostPlus",
  LIST_DOWN = "ListDown",
}
